// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"fe9b62b4","498":"249d39b6","513":"30b321bd","787":"3c6832f4"}[chunkId] + ".chunk.js";
};